var ctrlopt = ctrlopt,
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings || {};
  var oab = settings.oab || {};
  var auto_redirect = oab.auto_redirect;
  var servApptObj = [];
  // Hide zero service price for ALL Region
  var hideZeroServicePrice = $('#appointment-book-container').attr('data-disable-price') || 0;

  /* Concrete View */
  apptBook.ServicesSelectSection = function (container) {
    apptBook.ServicesSelectSection.superclass.constructor.call(this);
    this.id = 'services';
    this.container = container;
    this.servContainer = container.find('.services-container');
    this.services = this.servContainer.find('.service').css('display', 'none').detach();
    this.bookBar = container.find('.book-now-bar');
    this.bookBtn = this.bookBar.find('.button');
    this.initialised = false;
    this.minLabel = container.attr('data-minutes-label');
    this.maxSelections = parseInt(container.attr('data-max-select'));
    this.msOverlay = container.find('.appt-book-services-overlay').remove();
    this.jqBod = $('body');
    this.win = $(window);
    this.backTo = this.container.find('.back-to-link');
    this.boundRun = this.runBuild.bind(this);

    if (this.maxSelections === null || typeof this.maxSelections === 'undefined' || isNaN(this.maxSelections)) {
      this.maxSelections = 2;
    }
  };

  ctrlopt.extend(apptBook.ServicesSelectSection, apptBook.AbstractSection);

  apptBook.ServicesSelectSection.prototype.buildServices = function () {
    if (!this.buildParams || !this.buildParams.counterId) {
      return;
    }

    var serviceSelections, cServices,
      serviceMap = {},
      myServices = $(),
      me = this,
      isMobile = Unison.fetch.now() && Unison.fetch.now().name === 'small',
      currencySymbol = $('#appointment-book-sections').attr('data-currency-symbol');
    var hasVirtual = +localStorage.getItem('virtual_oab') || 0;
    var oab_price_decimal = oab.oab_price_decimal,
      oab_currency_position = oab.oab_currency_position;

    this.counterId = this.buildParams.counterId;
    this.serviceSelIds = this.buildParams.serviceIds;
    this.maxSelections = this.buildParams.maxSelections > 0 ? this.buildParams.maxSelections : this.maxSelections;
    var max_selected = this.maxSelections;

    for (var i = 0, len = this.servicesData.length; i < len; i += 1) {
      var s = this.servicesData[i];

      serviceMap[s.id] = s;
    }

    cServices = this.model.getCounterServices(this.buildParams.counterId);
    // hide back button for virtual services
    if (hasVirtual) {
      $(this.backTo).addClass('hidden');
    }
    this.backTo.off('click').click(function () {
      var updateData = {
        sectionId: 'previous',
        params: {
          counterId: me.counterId,
          updateMode: me.updateMode
        }
      };

      me.model.update(updateData);
    });

    if (cServices) {
      this.services.each(function () {
        var sdata, serv, selectorContainer,
          $this = $(this),
          onlineContentId = $this.attr('data-content-id'),
          currencyContent,
          priceContent,
          price;

        if (checkService(onlineContentId)) {
          sdata = me.model.getService(onlineContentId);
          if (sdata) {
            serv = $this.clone();
            currencyContent = serv.find('.selection-currency');
            priceContent = serv.find('.selection-price');
            serv.attr('data-total-duration', sdata.total_duration).find('.selection-time').text(sdata.total_duration + ' ' + me.minLabel);
            serv.attr('data-total-duration-with-padding', sdata.total_duration_with_padding);
            if (sdata.price !== null) {
              price = oab_price_decimal
                ? parseInt(sdata.price).toFixed(oab_price_decimal)
                : sdata.price;
              if (price === '0.00' && hideZeroServicePrice) {
                serv.attr('data-price', sdata.price).find('.selection-price').text();
                currencyContent.addClass('hidden');
              } else {
                serv.attr('data-price', sdata.price).find('.selection-price').text(price);
                currencyContent.text(currencySymbol);
              }
            }
            if (oab_currency_position === 'suffix') {
              priceContent.after(currencyContent);
              priceContent.append('&nbsp;');
            }
            serv.attr('data-service-id', sdata.id);

            selectorContainer = serv.find('.selection-selector');
            $('.selection-remove.link, .select.button', selectorContainer).click(function () {
              var selectionMarker,
                $this = $(this),
                $selectorContainer = $(selectorContainer),
                parentService = $this.parents('.service');

              if ($selectorContainer.hasClass('selected')) {
                selectionMarker = 'not-selected';
                $selectorContainer.removeClass('selected');
                parentService.removeClass('selected');
              } else {
                selectionMarker = 'selected';
                $selectorContainer.removeClass('not-selected');
                parentService.removeClass('not-selected');
              }
              $selectorContainer.addClass(selectionMarker);
              parentService.attr('data-status', selectionMarker).addClass(selectionMarker);
              updateBar(parentService);
              if ($selectorContainer.hasClass('selected') && (serviceSelections.length === max_selected) && auto_redirect) {
                checkServices($selectorContainer);
              }
            });
            if (me.serviceSelIds) {
              if (me.serviceSelIds.indexOf(parseInt(sdata.id)) > -1) {
                $('.select.button', selectorContainer).trigger('click');
              }
            }
          }

          myServices = myServices.add(serv);
        }
      });

      // me.services.detach();
      this.servContainer.append(myServices);
      myServices.css('display', 'block');

      if (myServices.length > 1 && !isMobile) {
        apptBook.equalHeights(myServices);
        setTimeout(onResize, 600);
      }

      updateBar();
      this.bookBtn.off('click');
      this.bookBtn.click(function () {
        checkServices(this);
      });

      this.win.on('resize', this.boundResize);
    }

    function checkServices(currentElement) {
      var updateData,
        anStr = serviceSelections.length + 'Apt',
        $this = $(currentElement);

      if ($this.hasClass('button--disabled')) {
        return;
      }
      if (site.track && typeof site.track.evtView === 'function') {
        var serviceNames = serviceSelections.map(function (element) {
          return element.serviceName.trim();
        }).join('|');

        site.track.evtLink({
          event_name: 'appointmentBooking_Service',
          event_category: 'appointment booking',
          event_action: 'services selected',
          event_label: serviceNames
        });
      }

      updateData = {
        sectionId: 'next',
        params: {
          counterId: me.counterId,
          services: serviceSelections,
          updateMode: me.updateMode
        }
      };
      me.model.update(updateData);
    }
    function checkService(id) {
      if (cServices) {
        for (var i = 0, len = cServices.length; i < len; i += 1) {
          var sId = cServices[i];

          if (id === serviceMap[sId].online_content_id) {
            return true;
          }
        }
      }

      return false;
    }

    function updateBar(lastSelection) {
      var sel,
        selected = me.servContainer.children('.selected'),
        totalTime = 0;

      serviceSelections = [];

      if (selected.length > me.maxSelections) {
        // alert("Whoops, selected too many. Sorry, can't do that.");

        me.jqBod.prepend(me.msOverlay);
        me.msOverlay.css('display', 'block').click(function (e) {
          e.preventDefault();
          me.msOverlay.remove();
        });

        if (lastSelection && selected.length === (me.maxSelections + 1)) {
          sel = lastSelection.removeClass('selected').attr('data-status', 'not-selected');
          sel.find('.selection-selector').removeClass('selected').addClass('not-selected');
        } else {
          for (var i = me.maxSelections, len = selected.length; i < len; i += 1) {
            sel = selected.eq(i).removeClass('selected').attr('data-status', 'not-selected');
            sel.find('.selection-selector').removeClass('selected').addClass('not-selected');
          }
        }
        updateBar();

        return;
      }

      selected.each(function () {
        var $this = $(this),
          time = parseInt($this.attr('data-total-duration')),
          timeWithPadding = parseInt($this.attr('data-total-duration-with-padding')),
          serviceId = parseInt($this.attr('data-service-id')),
          serviceName = $this.find('.service-title').text(),
          serviceDescription = $this.find('.lesson_description p').text(),
          servicePicture = $this.find('.service-image').attr('src'),
          servicePrice = $this.find('.selection-price').text();

        totalTime += time;
        serviceSelections.push({
          serviceId: serviceId,
          serviceDuration: time,
          serviceDurationWithPadding: timeWithPadding,
          serviceName: serviceName,
          serviceDescription: serviceDescription,
          servicePicture: servicePicture,
          servicePrice: servicePrice
        });
      });
      if (totalTime > 0) {
        me.bookBtn.removeClass('button--disabled');
        $('.services-container').addClass('selected');
      } else {
        me.bookBtn.addClass('button--disabled');
        $('.services-container').removeClass('selected');
      }
    }

    function onResize() {
      myServices.css('height', 'auto');
      if (myServices.length > 1 && !isMobile) {
        apptBook.equalHeights(myServices);
      }
    }

    this.boundResize = onResize.bind(this);

    this.win.on('resize', this.boundResize);
  };

  apptBook.ServicesSelectSection.prototype.runBuild = function () {
    this.buildServices();
  };

  apptBook.ServicesSelectSection.prototype.onUpdate = function (data) {
    var aPgName = document.title + ' - Services Select';

    if (this.boundResize) {
      this.win.off('resize', this.boundResize);
    }
    if (data.sectionId === this.id) {
      this.buildParams = data.params;
      if (data.params.updateMode) {
        this.updateMode = true;
      } else {
        this.updateMode = false;
      }
      this.servicesData = this.model.getServices();
      this.servContainer.empty();

      apptBook.sectionManager.on('transition_in_start', this.boundRun);
    } else {
      apptBook.sectionManager.off('transition_in_start', this.boundRun);
      if (data.params.appointmentId && servApptObj.length === 0 && data.sectionId === 'appointments') {
        runUpdateServiceAppointment(data.params.appointmentId, this);
      }
    }

    function runUpdateServiceAppointment(appointmentId, me) {
      me.model.getAppointment(appointmentId, function (apptData) {
        var updateData = {};
        var appointmentData = apptData,
          servs = appointmentData.services;

        for (var i = 0, len = servs.length; i < len; i += 1) {
          var servObj = servs[i];
          var $serviceInfo = me.services.filter('#service_' + servObj.online_content_id);
          var serviceInfoName = $serviceInfo.find('.service-title').text(),
            serviceInfoDescription = $serviceInfo.find('.lesson_description p').text(),
            serviceInfoPicture = $serviceInfo.find('.service-image').attr('src'),
            serviceInfoPrice = $serviceInfo.find('.selection-price').text();

          servApptObj.push({
            id: servObj.id,
            total_duration: servObj.total_duration,
            total_duration_with_padding: servObj.total_duration_with_padding,
            name: serviceInfoName || servObj.name,
            description: serviceInfoDescription || servObj.description,
            picture: serviceInfoPicture || servObj.picture,
            price: serviceInfoPrice || servObj.price
          });
        }
        updateData = {
          sectionId: 'appointments',
          params: {
            appointmentId: appointmentData.id,
            services: servApptObj
          }
        };
        me.model.update(updateData);
      }, function () { // If there is an error retrieving appointment id, go to beginning of APP
        var myUrl = [location.protocol, '//', location.host, location.pathname].join('');

        window.location = myUrl;
      });
    }
  };

  Drupal.behaviors.apptBookServices = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      var $servicesContainer = $('#services', context);
      var view = new apptBook.ServicesSelectSection($servicesContainer);

      view.setModel(apptBook.sectionModel).startObserving();
    },
    attached: false
  };
})(jQuery);
